import React, { Component } from 'react';
import Axios from 'axios';
import {peugeot_api_url} from 'peugeot_constants';
import {Link} from 'react-router-dom';
import { translate } from 'react-i18next';
import { tt } from 'peugeot_language';
var $ = window.jQuery;

class ModulePeugeotAccessariesCarousel extends Component {
    componentDidMount() {
        var that = this;
        Axios.get(peugeot_api_url + '/catalog_categories?_start=0&_end=100&type=auto&parent_id=12').then(function(resp){
            that.state = {
                items: resp.data
            };
            that.setState(that.state);
            var $owl = $('.owl-carousel');
            $owl.trigger('destroy.owl.carousel');
            // After destory, the markup is still not the same with the initial.
            // The differences are:
            //   1. The initial content was wrapped by a 'div.owl-stage-outer';
            //   2. The '.owl-carousel' itself has an '.owl-loaded' class attached;
            //   We have to remove that before the new initialization.
            $owl.html($owl.find('.owl-stage-outer').html()).removeClass('owl-loaded');
            $owl.owlCarousel({
                // your initial option here, again.
                loop: true,
                margin: 0,
                nav: true,
                dots: false,
                autoplaySpeed: 1000,
                navSpeed: 1000,
                paginationSpeed: 1000,
                slideSpeed: 1000,
                navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
                responsive: {
                    0: {
                        items: 1
                    },

                    480: {
                        items: 2
                    },

                    991: {
                        items: 2
                    },
                    1000: {
                        items: 3
                    }
                }
            });
        }).catch(function(err){
            console.log(err);
        });
    }
    render() {
        const { t } = this.props;
        return (
            <div className="section-full bg-img-fix dlab-new-work overlay-white-dark" style={{ backgroundImage: 'url(/img/bg1.jpg)'}}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-3 col-sm-4  p-a0 no-of-item">
                            <div className="no-of-item-dtl">
                                <img src="/img/Peugeot-logo.png" alt="Peugeot Logo" className="img-fluid" style={{width: '205px'}} />
                                <h3>{t('phutung_theoxe')}</h3>
                            </div>
                        </div>
                        <div className="col-md-9 col-sm-8 p-a0">
                            <div className="new-item owl-btn-style-1 owl-carousel">
                                {this.state? this.state.items.map(function(item, key){
                                    return (
                                        <div className="item dlab-new-item" key={key}>
                                            <div className="dlab-box">
                                                <div className="dlab-media">
                                                    <Link to={"/category/product/" + item.id + "/" + item.alias}><img src={item.image} alt={tt(item.title)} /></Link>
                                                </div>
                                                <div className="dlab-info">
                                                    <p className="event-date">{t('phutung')}</p>
                                                    <h4 className="dlab-title"><Link to={"/category/product/" + item.id + "/" + item.alias}>{tt(item.title)} <i className="fa fa-angle-right pull-right"></i></Link></h4>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }): ''}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(ModulePeugeotAccessariesCarousel);


// WEBPACK FOOTER //
// ./src/modules/Peugeot/Accessaries/Carousel.js